import React from 'react';
import { Route, Switch } from 'react-router-dom';

import http from 'api/http';
import {oilAPI} from 'api/requests';

import { ROUTE } from 'constants/routing';


import NotFoundScene from 'Scenes/NotFoundScene';
import BrandCreate from './Create';
import BrandDetails from './Details';
import BrandEdit from './Edit';
import {ROLES} from 'constants/roles';
import Store from '../../../../../registerIDBWorker';
import moment from 'moment';

class OilBranderRouter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      manufacturerAddressesWithCurrent: [],
    };
  }

  componentDidMount() {
    const { match } = this.props;

    if (isFinite(match.params.applicationId)) {
      http.get(oilAPI.brand(match.params.applicationId)).then(({ data }) => {
        this.setState({ applicationData: data });
        http.get(oilAPI.downloadBrandDocumentsList(data.number, data.year)).then(({ data }) => {
          let { applicationData } = this.state;
          applicationData.licenseAgreementList = data.sort((a, b) => {
            return moment(a.date).isAfter(b.date) ? -1 : 1;
          });
          this.setState({ applicationData });
        });
      });
    }
  }

  componentDidUpdate() {
    if (
      !this.state.manufacturerAddressesWithCurrent.length &&
      this.state.applicationData &&
      this.props.manufacturerAddresses
    )
      this.updateAddressesList();
  }

  updateAddressesList = () => {
    const { manufacturerAddresses } = this.props;
    const { manufacturerAddress } = this.state.applicationData;

    let manufacturerAddressesWithCurrent = [...manufacturerAddresses];

    if (manufacturerAddress) {
      let address = manufacturerAddresses.find(address => {
        let isSame = true;
        Object.keys(address.value).forEach(addressField => {
          if (address.value[addressField] !== manufacturerAddress[addressField]) isSame = false;
        });
        return isSame;
      });

      if (!address) {
        address = {
          name: [
            manufacturerAddress.address1,
            manufacturerAddress.address2,
            manufacturerAddress.address3,
            manufacturerAddress.address4,
            manufacturerAddress.city,
            manufacturerAddress.state,
            manufacturerAddress.postalCode,
            manufacturerAddress.country,
          ]
            .filter(object => object)
            .join(', '),
          value: { ...manufacturerAddress },
        };

        if (address.name) {
          manufacturerAddressesWithCurrent.unshift(address);
        }
      }
    }

    this.setState({ manufacturerAddressesWithCurrent });
  };

  updateListEntry = newEntry => {
    const { user } = this.props;
    const { applicationData } = this.state;

    let dataSource = newEntry.applicationStatus ? newEntry : { ...applicationData, applicationStatus: newEntry };

    Store.insert(`${user.getActiveRole()}_lists`, dataSource, user.getManufacturerCode());
    this.setState({ applicationData: dataSource });
  };

  deleteListEntry = () => {
    const { user } = this.props;
    const { applicationData } = this.state;

    Store.delete(`${user.getActiveRole()}_lists`, applicationData);
  };

  renderScene = Scene => {
    const { manufacturerAddresses } = this.props;
    const { applicationData, manufacturerAddressesWithCurrent } = this.state;
    return ({ match }) => {
      return (
        <Scene
          {...this.props}
          manufacturerAddresses={
            isFinite(match.params.applicationId) ? manufacturerAddressesWithCurrent : manufacturerAddresses
          }
          updateListEntry={this.updateListEntry}
          deleteListEntry={this.deleteListEntry}
          applicationData={applicationData}
          updateApplicationData={this.updateApplicationData}
          match={match}
        />
      );
    };
  };

  render() {
    const rootRoute = `${ROUTE.OIL_BRANDER}${ROLES.OIL_BRANDER.listSceneUrlPostfix}`;

    return (
      <Switch>
        <Route exact path={`${rootRoute}/new`} render={this.renderScene(BrandCreate)} />
        <Route exact path={`${rootRoute}/:applicationId`} render={this.renderScene(BrandDetails)} />
        <Route exact path={`${rootRoute}/:applicationId/edit`} render={this.renderScene(BrandEdit)} />
        <Route render={this.renderScene(NotFoundScene)} />
      </Switch>
    );
  }
}

export default OilBranderRouter;



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/index.jsx